import React from "react";
import { useDefaultTable } from "../../helpers/hooks";
import DefaultTable from "../../components/Common/DefaultTable";
import { threatLevel } from "../../constants/enums";
import { formatDatesOnList } from "helpers/utils";
import { Box, TableRow } from "@material-ui/core";
import ExpandableChips from "components/Common/ExpandableChips";

const getColor = (level) => {
  switch (level) {
    case threatLevel.AMBER:
      return "#E3792D";
    case threatLevel.RED:
      return "#EE2D2A";
    case threatLevel.WHITE:
      return "#FFFFFF";
    case threatLevel.GREEN:
      return "#43DD43";
    default:
      return "#FFFFFF";
  }
};

function AlertTable(props) {
  const {
    alerts,
    defaultTable,
    headCells,
    handleEntityClick,
    isLoading,
    optionalCellRender,
  } = props;

  const { renderHeadCell, renderBodyCell } = defaultTable;

  function styleCell(cell, value) {
    if (cell === "threatLevel") {
      return {
        color: getColor(value),
      };
    }
    return null;
  }

  const renderDefaultBody = () => {
    return alerts.map((alert) => {
      const { id } = alert;

      return (
        <TableRow
          hover
          role="checkbox"
          onClick={() => {
            handleEntityClick(alert);
          }}
          tabIndex={-1}
          key={id}
          style={{
            width: "100px",
          }}
        >
          {optionalCellRender("id", renderBodyCell(id))}
          {optionalCellRender("shortName", renderBodyCell(alert.shortName))}
          {optionalCellRender("category", renderBodyCell(alert.category))}

          {optionalCellRender(
            "cves",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  maxWidth: "182px",
                  width: `${alert?.cves?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={alert?.cves?.map((x) => x.cveId) ?? []}
                  incrementalLength={4}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "150px",
                  }}
                />
              </Box>,
              { width: 150 }
            )
          )}

          {optionalCellRender(
            "attacks",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  maxWidth: "182px",
                  width: `${alert?.attacks?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={alert?.attacks?.map((x) => x.name) ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "150px",
                  }}
                />
              </Box>,
              { width: 150 }
            )
          )}

          {optionalCellRender(
            "actors",
            renderBodyCell(
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  maxWidth: "182px",
                  width: `${alert?.actors?.length * 36}px`,
                  my: 1,
                  gap: 1,
                }}
              >
                <ExpandableChips
                  dataArray={alert?.actors?.map((x) => x.name) ?? []}
                  style={{
                    maxWidth: 100,
                    minWidth: 150,
                    fontWeight: 500,
                  }}
                  ellipsisProps={{
                    maxWidth: "150px",
                  }}
                />
              </Box>,
              { width: 150 }
            )
          )}

          {optionalCellRender(
            "cisa",
            renderBodyCell(
              typeof alert.cisa === "boolean"
                ? alert.cisa === true
                  ? "Yes"
                  : "No"
                : "Unknown"
            )
          )}
          {optionalCellRender(
            "threatLevel",
            renderBodyCell(alert.threatLevel, {
              color: getColor(alert.threatLevel),
            })
          )}
          {optionalCellRender(
            "lastUpdatedAt",
            renderBodyCell(alert.lastUpdatedAt)
          )}
          {optionalCellRender(
            "createdByName",
            renderBodyCell(alert.createdBy?.username, { width: 100 })
          )}
        </TableRow>
      );
    });
  };

  return (
    <DefaultTable
      headCells={headCells}
      onRowClick={handleEntityClick}
      renderDefaultBody={renderDefaultBody}
      renderHeadCell={renderHeadCell}
      styleCell={styleCell}
      rows={alerts}
      isLoading={isLoading}
    />
  );
}

export default AlertTable;
